import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getintake } from "../actions/intakeActions";

const PreferredIntake = React.memo(() => {
  const dispatch = useDispatch();

  const intakeList = useSelector((state) => state.intakeList);
  const { intakes, loading, error } = intakeList;

  useEffect(() => {
    if (!intakes) {
      dispatch(getintake());
    }
  }, [intakes]);
  return (
    <>
      {loading ? (
        <>loading...</>
      ) : (
        <>
          {intakes ? (
            intakes.map((intak, i) => (
              <option key={i + 11} value={intak.Intake}>
                {intak.Intake}
              </option>
            ))
          ) : (
            <>
              <option>Loading...</option>
            </>
          )}
        </>
      )}
    </>
  );
});

export default PreferredIntake;
